import React from "react";
import { cities } from "../mock";
import Reveal from "./Reveal";
import { MapPin } from "lucide-react";

const Cities = () => {
  return (
    <section id="cities" className="section bg-[#1a3a2e] relative overflow-hidden">
      {/* subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, #c9a55c 1px, transparent 0)",
        backgroundSize: "36px 36px"
      }} />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <Reveal>
          <div className="text-center mb-16">
            <span className="font-script text-[#e9c987] text-3xl block mb-2">the route</span>
            <h2 className="font-display text-[#faf5ec] text-4xl md:text-5xl mb-4">
              Five Cities, One <em className="italic text-[#e9c987]">Festive</em> Story
            </h2>
            <p className="text-[#faf5ec]/70 max-w-2xl mx-auto font-light">
              We thread our way through Europe&rsquo;s most enchanting Christmas capitals — connected by scenic high-speed trains and tucked-away hotels.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cities.map((c, idx) => (
            <Reveal key={c.name} delay={idx * 90}>
              <article
                className={`city-card group relative overflow-hidden rounded-sm h-[420px] cursor-pointer ${
                  idx % 2 === 1 ? "lg:mt-10" : ""
                }`}
              >
                <div
                  className="city-image absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: `url(${c.image})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0c1a14]/95 via-[#0c1a14]/30 to-transparent" />
                <div className="absolute top-4 left-4 px-3 py-1 bg-[#c9a55c] text-[#1a3a2e] text-[10px] tracking-[0.25em] uppercase font-semibold rounded-sm">
                  {c.days}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-center gap-1.5 text-[#e9c987] text-[11px] tracking-[0.3em] uppercase mb-2">
                    <MapPin className="w-3 h-3" strokeWidth={2} />
                    {c.country}
                  </div>
                  <h3 className="font-display text-[#faf5ec] text-3xl mb-2 leading-none">{c.name}</h3>
                  <p className="text-[#faf5ec]/85 text-sm leading-relaxed font-light max-h-0 overflow-hidden group-hover:max-h-32 transition-[max-height] duration-500">
                    {c.blurb}
                  </p>
                </div>
                <div className="absolute inset-0 ring-0 group-hover:ring-1 ring-[#c9a55c]/60 transition-all duration-500" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cities;
